import { render, staticRenderFns } from "./kaoshi.vue?vue&type=template&id=2d7f8ea8&scoped=true"
import script from "./kaoshi.vue?vue&type=script&lang=js"
export * from "./kaoshi.vue?vue&type=script&lang=js"
import style0 from "./kaoshi.vue?vue&type=style&index=0&id=2d7f8ea8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7f8ea8",
  null
  
)

export default component.exports